<template>
  <div class="container-page">
    <div>
      <p class="title-inner">Каталог услуг</p>
      <div class="mb-16">
        <ButtonComponent mod="gradient-bg" @click="editCard(0)">Создать</ButtonComponent>
      </div>
      <div class="mb-4">
        <DefaultFilter :filterValue="filter" @loadFilter="onLoadFilter" />
      </div>
      <div v-if="page.items">
        <div class="table-container mb-16 js-table-arrow">
          <table class="stockTable">
            <thead>
              <tr>
                <th>Наименование</th>
                <th>Код</th>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <th class="filter">
                  <FilterInput
                    v-model="filter.name"
                    placeholder="Найти по наименованию..."
                    v-on:valueChangedDebounced="changeFilter"
                  />
                </th>
                <th class="filter">
                  <FilterInput
                    v-model="filter.code"
                    placeholder="Найти по коду..."
                    v-on:valueChangedDebounced="changeFilter"
                  />
                </th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="page.items.length">
              <tr v-for="item in page.items" :key="item.id">
                <td
                  :class="{ textupper: item.level === 1, textbold: !item.isLeaf }"
                  :style="{ paddingLeft: item.level * 10 + 'px' }"
                >
                  <i v-if="!item.isLeaf" class="fas fa-folder"></i>
                  {{ item.name }}
                </td>
                <td>{{ item.code }}</td>
                <td>
                  <IconComponent @click="editCard(item.id)" name="mode" />
                </td>
                <td>
                  <IconComponent @click="deleteCard(item.id)" name="delete" />
                </td>
              </tr>
            </tbody>
            <tbody v-if="!page.items.length">
              <tr>
                <td class="text-center" colspan="4">Нет данных.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="page.pagesTotal > 1">
          <Pagination
            :pageCount="page.pagesTotal"
            :currentPage="page.pageNumber"
            @change="onPageChange($event, false)"
            @more="onPageChange($event, true)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import FilterInput from '../../../common/components/FilterInput.vue';
  import IconComponent from '../../../common/ui/IconComponent.vue';
  import API from '../api/nsi';

  export default {
    name: 'Okved',
    components: { FilterInput, IconComponent, ButtonComponent, DefaultFilter },
    data() {
      return {
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        filter: {
          name: null,
          code: null,
        },
      };
    },
    created() {
      loadFilter(this.$options.name).then((response) => {
        let filter = response;
        if (filter) {
          this.filter = filter;
        }
        this.loadPage(false);
      });
    },
    methods: {
      loadPage(append) {
        const request = Object.assign(this.filter, this.request);
        API.search('nsiokved', request).then((response) => {
          if (!append) {
            this.page = {};
            this.$nextTick(() => {
              this.page = response.data;
            });
          } else if (response.data) {
            this.page.pageNumber = response.data.pageNumber;
            this.page.items = this.page.items.concat(response.data.items);
          }
        });
      },
      editCard(id) {
        this.$router.push({ name: 'TnvedCard', params: { id: id, action: 'edit' } });
      },
      deleteCard(id) {
        Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
          if (res.isConfirmed) {
            API.delete(id)
              .then((response) => {
                console.log(response);
                Constants.alert.fire('Удаление', 'Запись удалена', 'success');
                this.loadPage();
              })
              .catch((error) => {
                Constants.alert.fire(
                  'Удаление',
                  error.response && error.response.data ? error.response.data : 'Запись не удалена',
                  'error',
                );
              });
          }
        });
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon {
    color: $green;
  }
  .textupper {
    text-transform: uppercase;
  }
  .textbold {
    font-weight: bold;
  }
</style>
